import { DeleteOutlined } from '@ant-design/icons'
import { message } from 'antd'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { ButtonCommon } from 'src/common'
// import { selectCurrentDictWordIDFromDef } from 'src/redux/definition/definition.selector'
import { onDeleteDictWord } from 'src/redux/dict/dict.action'
import ActionCommon from '../../../../common/ActionCommon/ActionCommon'
import PopconfirmCommon from '../../../../common/PopconfirmCommon/PopconfirmCommon'
import {
	useAppDispatch,
	// useAppSelector
} from '../../../../hooks'

export const DictWordsAction = ({ data, onEdit }) => {
	const dispatch = useAppDispatch()
	// const id = useAppSelector(selectCurrentDictWordIDFromDef)

	const [visible, setVisible] = useState(false)
	const [confirmLoading, setConfirmLoading] = useState(false)

	const onConfirmDelete = () => {
		setConfirmLoading(true)
		dispatch(
			onDeleteDictWord(
				{
					id: data.id,
				},
				onDeleteCallback
			)
		)
	}

	const onCancel = () => {
		setVisible(false)
	}

	const onDeleteCallback = (isSuccess, rs) => {
		if (isSuccess) {
			setConfirmLoading(false)
			setVisible(false)
		} else {
			message.error(rs)
		}
	}

	const showPopconfirm = () => {
		setVisible(true)
	}

	return (
		<div className="u-row-center">
			<PopconfirmCommon
				visible={visible}
				onConfirm={onConfirmDelete}
				title="Are you sure to delete this word and related data permanently?"
				placement="left"
				okButtonProps={{ loading: confirmLoading }}
				onCancel={onCancel}
			>
				<ButtonCommon onClick={showPopconfirm}>
					<DeleteOutlined />
				</ButtonCommon>
			</PopconfirmCommon>
			<ActionCommon onEditClick={onEdit} record={data} />
		</div>
	)
}

DictWordsAction.propTypes = {
	data: PropTypes.any,
	onEdit: PropTypes.func,
}
